import React from 'react'

import { FiltersSidebar, Icon, Verified } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  array, bool, func, object, string,
} from 'prop-types'

import WithListingPageContext from 'Pods/ListingPage/Components/WithListingPageContext'

import getArrayFilters from 'Utils/getArrayFilters'
import useBreakpoint from 'Utils/useBreakpoint'

import getContentRestrictionFilters from './Utils/getContentRestrictionFilters'

function RemainingContentRestrictionFilters({
  selectedFilters,
  setSelectedFilters,
  isCurrentUser,
  filters,
  followingFilter = null,
  label,
  trackFilterChange,
  locale = 'en',
}) {
  const windowSize = useBreakpoint()
  const shouldDisplayTitleDivider = ['xs', 'sm'].includes(windowSize)
  const userDependentFilters = getContentRestrictionFilters(isCurrentUser, locale)
  const effectiveFollowingFilter = windowSize !== 'xs' ? followingFilter : null
  const contentRestrictionFilters = [
    ...filters,
    userDependentFilters[0],
    effectiveFollowingFilter,
    userDependentFilters[1],
    userDependentFilters[2],
  ].filter(Boolean)
  const groupsSelectedFilters = selectedFilters.licenses || []
  const currentSelectedFilters = getArrayFilters(groupsSelectedFilters)
  const isFollowingSelected = selectedFilters?.designers?.following === '1'
  const currentSelectedFiltersWithFollowing = (
    followingFilter && isFollowingSelected
      ? [...currentSelectedFilters, followingFilter.value]
      : currentSelectedFilters
  )

  function handleFilterChange(selectedValues) {
    let truthyValues = selectedValues.filter(Boolean)
    const followingValue = followingFilter?.value
    const isFollowingSelectedNext = followingValue ? truthyValues.includes(followingValue) : false
    const shouldSkipLastSelectedFilter = isFollowingSelectedNext !== isFollowingSelected

    if (followingValue) {
      truthyValues = truthyValues.filter((value) => value !== followingValue)
    }

    const newValues = [...new Set(truthyValues)]

    const newFilter = newValues
      .filter((element) => currentSelectedFilters.every((value) => value !== element))

    const isFilterSelected = newFilter.length > 0
    const isFilterDeselected = newFilter.length < currentSelectedFilters.length

    if (isFilterSelected) {
      const newFilterValue = newFilter.pop()

      trackFilterChange({
        name: 'licenses',
        value: newFilterValue,
      })
    }

    if (isFilterDeselected) {
      const deselectedFilter = currentSelectedFilters
        .find((element) => newValues.every((value) => value !== element))

      window.removeCurrentSearchFilter({
        name: 'licenses',
        value: deselectedFilter,
      })
    }

    if (followingValue) {
      if (!isFollowingSelected && isFollowingSelectedNext) {
        trackFilterChange({
          name: 'designers',
          value: followingValue,
        })
      } else if (isFollowingSelected && !isFollowingSelectedNext) {
        window.removeCurrentSearchFilter({
          name: 'designers',
          value: followingValue,
        })
      }
    }

    let nextDesigners = selectedFilters.designers
    if (followingValue) {
      nextDesigners = isFollowingSelectedNext ? { following: '1' } : {}
    }

    setSelectedFilters({
      name: 'licenses',
      value: newValues,
      newObject: {
        ...selectedFilters,
        licenses: newValues,
        designers: nextDesigners,
      },
      skipGetLastSelectedFilter: shouldSkipLastSelectedFilter && !isFilterSelected && !isFilterDeselected,
    })
  }

  return (
    <div className="remaining-filters__content-restriction">
      <FiltersSidebar
        isCollapsible={false}
        filters={[
          {
            filters: contentRestrictionFilters,
            label,
            withTitleDivider: shouldDisplayTitleDivider,
          },
        ]}
        selectedFilters={currentSelectedFiltersWithFollowing}
        onFiltersChange={handleFilterChange}
        expandCheckboxLabel
        isControlled
        dividerClassName="remaining-filters__divider"
        useNewCheckboxes
      />
    </div>
  )
}

RemainingContentRestrictionFilters.propTypes = {
  selectedFilters: object.isRequired,
  setSelectedFilters: func.isRequired,
  isCurrentUser: bool.isRequired,
  filters: array.isRequired,
  followingFilter: object,
  label: string.isRequired,
  trackFilterChange: func.isRequired,
  locale: string,
}


const mapStateToProps = ({
  selectedFilters,
  setSelectedFilters,
  isCurrentUser,
  filtersOptions,
  trackFilterChange,
  locale,
  subscriptionFlowEnabled,
}) => {
  const currentFilters = filtersOptions.licenses
  const followingFilter = subscriptionFlowEnabled
    ? filtersOptions?.designers?.filters?.find(({ value }) => value === 'following')
    : null
  const { filters, label } = currentFilters || {}

  const modifiedFilters = filters?.map((f) => {
    if (f?.value === 'cgt_standard_only' && typeof f.label === 'string') {
      return {
        ...f,
        label: (
          <span className="remaining-filters__filter-label-with-icon">
            <span>{f.label}</span>
            <Icon notSpaced svgComponent={Verified} color="primary" size="small" />
          </span>
        ),
      }
    }
    return f
  })

  return {
    selectedFilters,
    setSelectedFilters,
    isCurrentUser,
    filters: modifiedFilters,
    followingFilter,
    label,
    trackFilterChange,
    locale,
  }
}

export default WithListingPageContext(mapStateToProps)(
  RemainingContentRestrictionFilters
)
